module.exports = __webpack_public_path__ + "static/icons/icon-mountain--mid-6177d380506de9f4941d815f468e5537.svg";